import { ACCOUNTS_BASE_URL_KEY } from 'state_management/accounts/http_client';
import { CHAT_SERVER_URL_KEY, PDF_SERVER_KEY } from 'state_management/constants';
import { BASE_URL_KEY } from 'state_management/env_constants';

// localStorage keys that redirect the app at local/localhost service endpoints instead of the
// default remote gateway. These are developer-only overrides, so a fresh session must always start
// from the remote defaults.
const LOCAL_SERVICE_OVERRIDE_KEYS = [BASE_URL_KEY, ACCOUNTS_BASE_URL_KEY, CHAT_SERVER_URL_KEY, PDF_SERVER_KEY];

/**
 * Removes every local/localhost service endpoint override from localStorage and returns whether any
 * override was actually set.
 *
 * Callers should force a full page reload when this returns true. Several module-level singletons
 * read these endpoints only once, at load time, and cannot be redirected within the same tab by
 * clearing localStorage alone. The clearest example is the Liveblocks realtime client
 * (`state_management/collab/client.ts`), whose websocket URL is captured from BASE_URL when the
 * module is first evaluated, so it keeps targeting localhost until the page reloads.
 */
export const clearLocalServiceOverrides = (): boolean => {
  let hadOverride = false;
  for (const key of LOCAL_SERVICE_OVERRIDE_KEYS) {
    if (localStorage.getItem(key) != null) {
      hadOverride = true;
    }
    localStorage.removeItem(key);
  }
  return hadOverride;
};
